// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.label-area > .label-content.error .el-input__inner, .label-area > .label-content.error textarea {\n    border-color: red;\n}\n", ""]);
// Exports
module.exports = exports;
